import { CheckCircle2, ShoppingCart, ShieldCheck, Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface ProductCardProps {
  badge?: string;
  title: string;
  description: string;
  price?: string;
  priceNote?: string;
  features: string[];
  stripeUrl: string;
  ctaLabel?: string;
}

const ProductCard = ({
  badge = "Compra online",
  title,
  description,
  price,
  priceNote = "Pago único · IVA incluido",
  features,
  stripeUrl,
  ctaLabel = "Pagar ahora",
}: ProductCardProps) => {
  return (
    <section>
      <div className="max-w-4xl mx-auto">
        <Card className="overflow-hidden border-2 border-primary/30 shadow-glow">
          <div className="grid md:grid-cols-2">
            {/* Left: info */}
            <div className="p-8 md:p-10 bg-gradient-to-br from-primary/5 via-accent/5 to-primary/10 border-b md:border-b-0 md:border-r border-border">
              <Badge variant="secondary" className="mb-4">{badge}</Badge>
              <h3 className="text-2xl md:text-3xl font-bold mb-3 leading-tight">{title}</h3>
              <p className="text-muted-foreground text-sm mb-6">{description}</p>
              {price && (
                <div className="mb-2">
                  <div className="flex items-baseline gap-2">
                    <span className="text-4xl md:text-5xl font-bold text-foreground">{price}</span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">{priceNote}</p>
                </div>
              )}
            </div>

            {/* Right: features + CTA */}
            <div className="p-8 md:p-10 flex flex-col">
              <ul className="space-y-3 mb-8 flex-1">
                {features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <CheckCircle2 size={16} className="text-primary shrink-0 mt-0.5" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href={stripeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-pill bg-primary text-primary-foreground hover:shadow-glow px-6 py-4 inline-flex items-center justify-center gap-2 w-full"
              >
                <ShoppingCart size={16} />
                {ctaLabel}
              </a>

              <div className="flex items-center justify-center gap-4 mt-4 text-xs text-muted-foreground">
                <span className="flex items-center gap-1"><Lock size={12} /> Pago seguro Stripe</span>
                <span className="flex items-center gap-1"><ShieldCheck size={12} /> Factura incluida</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default ProductCard;
